// =============================
// Imports
// =============================

// External Dependencies
import { connect } from 'react-redux';

// Actions
import {
  clearNotification,
  clearAllNotifications,
} from '../../../store/actions/NotificationActions';

// Components
import NotificationsList from '../../presentationals/notificationsList';

// =============================
// Component
// =============================

function mapStateToProps({ notifications }) {
  return {
    notifications,
  };
}

export default connect(mapStateToProps, { clearNotification, clearAllNotifications })(
  NotificationsList,
);
